import { render, staticRenderFns } from "./CreateDiseaseWithTemplate.vue?vue&type=template&id=94a99b30&scoped=true"
import script from "./CreateDiseaseWithTemplate.vue?vue&type=script&lang=js"
export * from "./CreateDiseaseWithTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a99b30",
  null
  
)

export default component.exports